import React from 'react'
import { RadioButtonProps } from './radioButton.type'
import classNames from 'classnames'

import * as styles from './radioButton.module.scss'
import Tooltip from '../tooltip/tooltip'

const RadioButton: React.FunctionComponent<RadioButtonProps> = ({
   children,
   id,
   groupName = 'radioGroup',
   action,
   getList,
   buttonRef,
   resetRef,
   variant = 'standard',
   disabled = false,
   checked = false,
   preSelected = false,
   style,
   hide = false,
   tooltip,
}) => {
   const classes = classNames(styles.radioButton, {
      [styles.radioButtonStandard]: variant === 'standard',
      [styles.radioButtonIcon]: variant === 'icon',
      [styles.radioButtonFilter]: variant === 'filter',
      [styles.buttonReset]: !!buttonRef,
      [styles.checked]: preSelected || checked,
      [styles.disabled]: disabled,
   })

   const ref = buttonRef ?? resetRef

   if (hide) {
      return null
   }

   return tooltip && !disabled ? (
      <Tooltip content={tooltip}>
         <div className={classes}>
            <input
               key={id}
               disabled={disabled}
               ref={ref}
               type="radio"
               id={id}
               name={groupName}
               onClick={getList || action}
               defaultChecked={checked}
            />
            <label htmlFor={id} style={style}>
               {children}
            </label>
         </div>
      </Tooltip>
   ) : (
      <div className={classes}>
         <input
            key={id}
            disabled={disabled}
            ref={ref}
            type="radio"
            id={id}
            name={groupName}
            onClick={getList || action}
            defaultChecked={checked}
         />
         <label htmlFor={id} style={style}>
            {children}
         </label>
      </div>
   )
}

export default RadioButton
